import { effectiveProductCategory, normalizeProductSearchQuery } from '@longjie/shared';

/** Every product search uses the warehouse hierarchy and the same keyword/category policy. */
export function productSearchPath(endpoint: string, search: string, categoryId = '', pagination?: { page: number; pageSize: number }) {
  const params = new URLSearchParams(pagination ? { page: String(pagination.page), pageSize: String(pagination.pageSize) } : {});
  const query = normalizeProductSearchQuery(search);
  const category = effectiveProductCategory(query, categoryId);
  if (query) params.set('query', query);
  if (category) {
    params.set(category.startsWith('code:') ? 'categoryPrefix' : 'categoryId', category.startsWith('code:') ? category.slice(5) : category);
  }
  const encoded = params.toString();
  return encoded ? `${endpoint}?${encoded}` : endpoint;
}

export function catalogSelectionPath(endpoint: string, search: string, categoryId: string, page = 1, pageSize = 30) {
  return productSearchPath(endpoint, search, categoryId, { page, pageSize });
}
